export function assert(
  expression: boolean,
  error = new Error('Assertion Failed'),
): asserts expression {
  if (!expression) {
    throw error;
  }
}
